// 화면 오류 경계 — 호스트가 직접 그리는 화면(내 일정 등)이 렌더 중 예외를 던져도 호스트 전체(상단바·사이드바·다른 화면)가 죽지 않게 한다.
//
// 대표 원인: 공용 킷(yukimushi-component-fe)의 dist 가 소스보다 오래돼 새로 쓰는 부품이 `undefined` 로 import 되는 경우
// (「Element type is invalid」). 개발 서버에서 킷을 고친 뒤 빌드하지 않았을 때 자주 난다 — 개발 빌드에서는 그 해결법을 함께 보인다.
// 클래스 컴포넌트다(React 16 에는 오류 경계용 훅이 없다).
import React from 'react';
import { getLang, translate } from '../lib/locale';

interface Props {
  /** 화면 이름 — 콘솔 로그에만 쓴다 */
  name: string;
  children: React.ReactNode;
}

interface State {
  error: Error | null;
}

const IS_DEV = process.env.NODE_ENV !== 'production';

export default class PaneBoundary extends React.Component<Props, State> {
  state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo): void {
    // 호스트 화면이 죽는 것은 막되 원인은 콘솔에 남긴다
    // eslint-disable-next-line no-console
    console.error(`[${this.props.name}] 화면을 그리지 못했습니다`, error, info.componentStack);
  }

  render(): React.ReactNode {
    if (!this.state.error) return this.props.children;
    const lang = getLang();
    return (
      <div role="alert" style={{ padding: 24, maxWidth: 560 }}>
        <h2 style={{ margin: '0 0 8px', fontSize: 16 }}>{translate(lang, 'pane.error.title')}</h2>
        <p style={{ margin: '0 0 12px', fontSize: 13, color: '#4b5a71' }}>{translate(lang, 'pane.error.body')}</p>
        {IS_DEV && (
          <p style={{ margin: '0 0 12px', fontSize: 12, color: '#b45309', background: '#fffbeb', border: '1px solid #fde68a', borderRadius: 6, padding: '8px 10px' }}>
            {translate(lang, 'pane.error.devHint')}
            <br />
            <code>{this.state.error.message}</code>
          </p>
        )}
        <button type="button" onClick={() => this.setState({ error: null })}
          style={{ height: 30, padding: '0 14px', border: '1px solid #d5dde9', borderRadius: 6, background: '#fff', cursor: 'pointer' }}>
          {translate(lang, 'pane.error.retry')}
        </button>
      </div>
    );
  }
}
